import React from 'react';
import PropTypes from 'prop-types';

export default function ButtonClear(props) {
    return (
        <button
            className="tb-form__restart-btn button-tertiary"
            type="button"
            onClick={props.onClick}>
            <span className="button-content button-content--icon">
                <span>{props.children}</span>
                <svg className="icon button-tertiary__icon" width="18" height="18" focusable="false">
                    <use xlinkHref="#icon-restart"></use>
                </svg>
            </span>
        </button>
    );
}

ButtonClear.propTypes = {
    children: PropTypes.string,
    onClick: PropTypes.func.isRequired
};
